import { render, staticRenderFns } from "./BrowserNavigation.vue?vue&type=template&id=4026d025"
import script from "./BrowserNavigation.vue?vue&type=script&lang=js"
export * from "./BrowserNavigation.vue?vue&type=script&lang=js"
import style0 from "./BrowserNavigation.vue?vue&type=style&index=0&id=4026d025&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports